<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-title"><a id="pagevii">List of Maps</a></h2><a id="pagevii">
<h3 class="ch-map"><em class="italic">Maps by Edward Alexander</em></h3>
<h3 class="ch-map1"><em class="italic">Make Me a Map, LLC</em></h3>
<p class="ch-map2">H<span class="small">OWE’S</span> V<span class="small">OYAGE</span></p>
<p class="ch-map2">P<span class="small">HILADELPHIA</span> C<span class="small">AMPAIGN</span></p>
<p class="ch-map2">V<span class="small">ALLEY</span> F<span class="small">ORGE</span> E<span class="small">NCAMPMENT</span></p>
<p class="ch-map2">P<span class="small">HILADELPHIA</span> R<span class="small">EGION</span></p>
<p class="ch-map2">B<span class="small">ATTLE</span> <span class="small">OF</span> B<span class="small">ARREN</span> H<span class="small">ILL</span></p>
<p class="ch-map3">V<span class="small">ALLEY</span> F<span class="small">ORGE</span> D<span class="small">RIVING</span> T<span class="small">OUR</span></p>
<div class="img_container1a">
<img alt="image" src="images/pg7_a.jpg"/>
<p class="caption_center">Baron von Stueben’s appearance, and the discipline and drill he brought with him, was a turning point of the war. (<span class="small_1">cm</span>)</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// List_of_Maps.vue?5646a407